var render = function () {
  var _vm$companyData, _vm$companyData2, _vm$companyData2$pack, _vm$companyData3, _vm$companyData3$pack, _vm$companyData4, _vm$companyData4$pack, _vm$companyData5, _vm$companyData5$pack, _vm$selectedPayment, _vm$companyInformatio, _vm$companyInformatio2, _vm$companyInformatio3, _vm$companyInformatio4, _vm$companyInformatio5, _vm$companyInformatio6, _vm$companyInformatio7, _vm$companyInformatio8, _vm$companyInformatio9, _vm$companyInformatio10, _vm$companyInformatio11, _vm$companyInformatio12, _vm$selectedPayment2, _vm$selectedPayment3, _vm$selectedPayment4, _vm$selectedPayment5, _vm$selectedPayment6, _vm$selectedPayment7, _vm$selectedPayment8, _vm$selectedPayment9;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-card', [_c('b-card-body', [_c('b-card-text', [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "6",
      "cols": "12"
    }
  }, [[_c('h5', {
    staticClass: "text-capitalize"
  }, [_vm._v("Current Package")]), (_vm$companyData = _vm.companyData) !== null && _vm$companyData !== void 0 && _vm$companyData.package ? _c('div', [_c('b-card-text', [_c('strong', [_vm._v("Title:")]), _vm._v(" " + _vm._s((_vm$companyData2 = _vm.companyData) === null || _vm$companyData2 === void 0 ? void 0 : (_vm$companyData2$pack = _vm$companyData2.package) === null || _vm$companyData2$pack === void 0 ? void 0 : _vm$companyData2$pack.title))]), _c('b-card-text', [_c('strong', [_vm._v("Billing Cycle:")]), ((_vm$companyData3 = _vm.companyData) === null || _vm$companyData3 === void 0 ? void 0 : (_vm$companyData3$pack = _vm$companyData3.package) === null || _vm$companyData3$pack === void 0 ? void 0 : _vm$companyData3$pack.billing_cycle) === 'monthly' ? [_vm._v(" Monthly ")] : ((_vm$companyData4 = _vm.companyData) === null || _vm$companyData4 === void 0 ? void 0 : (_vm$companyData4$pack = _vm$companyData4.package) === null || _vm$companyData4$pack === void 0 ? void 0 : _vm$companyData4$pack.billing_cycle) === 'yearly' ? [_vm._v(" Yearly ")] : [_vm._v(" Life Time ")]], 2), _c('b-card-text', [_c('strong', [_vm._v("Max User:")]), _vm._v(" " + _vm._s((_vm$companyData5 = _vm.companyData) === null || _vm$companyData5 === void 0 ? void 0 : (_vm$companyData5$pack = _vm$companyData5.package) === null || _vm$companyData5$pack === void 0 ? void 0 : _vm$companyData5$pack.max_user) + " users")])], 1) : _vm._e()]], 2), _c('b-col', {
    attrs: {
      "lg": "6",
      "cols": "12"
    }
  }, [_c('b-card-text', [_c('strong', [_vm._v("Subscription Expire Date:")]), _vm._v(" " + _vm._s(_vm.subscriptionExpireDate ? _vm.formatSubscriptionExpiredDateTime(_vm.subscriptionExpireDate) : 'N/A'))]), _c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 159, 67, 0.15)',
      expression: "'rgba(255, 159, 67, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "border",
    attrs: {
      "variant": "flat-warning"
    },
    on: {
      "click": function click($event) {
        _vm.showModal = true;
      }
    }
  }, [_vm._v(" Cancel Subscription ")]), _c('router-link', {
    attrs: {
      "to": "/pricing"
    }
  }, [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(40, 199, 111, 0.15)',
      expression: "'rgba(40, 199, 111, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "border mx-1",
    attrs: {
      "variant": "flat-success"
    }
  }, [_vm._v(" Update Package ")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _c('b-card', [_c('div', [_c('vue-good-table', {
    attrs: {
      "styleClass": "vgt-table table-custom-style striped",
      "line-numbers": false,
      "mode": "remote",
      "totalRows": _vm.totalRecords,
      "isLoading": _vm.isLoading,
      "rows": _vm.rows,
      "columns": _vm.columns,
      "sort-options": {
        enabled: false,
        multipleColumns: true,
        initialSortBy: [{
          field: 'created_at',
          type: 'desc'
        }]
      },
      "pagination-options": {
        enabled: true,
        perPage: _vm.pageLength
      }
    },
    on: {
      "on-page-change": _vm.onPageChange,
      "on-sort-change": _vm.onSortChange,
      "on-column-filter": _vm.onColumnFilter,
      "on-per-page-change": _vm.onPerPageChange,
      "update:isLoading": function updateIsLoading($event) {
        _vm.isLoading = $event;
      },
      "update:is-loading": function updateIsLoading($event) {
        _vm.isLoading = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function fn(props) {
        var _props$column, _props$column2, _props$column3, _props$row, _props$row$currency, _props$column4, _props$column5, _props$column6;
        return [(props === null || props === void 0 ? void 0 : (_props$column = props.column) === null || _props$column === void 0 ? void 0 : _props$column.field) === 'format_created_at' ? [props.row.created_at ? _c('div', [_vm._v(" " + _vm._s(_vm.formatDateTime(props.row.created_at)) + " ")]) : _vm._e()] : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column2 = props.column) === null || _props$column2 === void 0 ? void 0 : _props$column2.field) === 'format_updated_at' ? [props.row.updated_at ? _c('div', [_vm._v(" " + _vm._s(_vm.formatDateTime(props.row.updated_at)) + " ")]) : _vm._e()] : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column3 = props.column) === null || _props$column3 === void 0 ? void 0 : _props$column3.field) === 'format_amount' ? [props.row.amount_paid ? _c('div', [_c('div', [_vm._v(" " + _vm._s(props === null || props === void 0 ? void 0 : (_props$row = props.row) === null || _props$row === void 0 ? void 0 : (_props$row$currency = _props$row.currency) === null || _props$row$currency === void 0 ? void 0 : _props$row$currency.toUpperCase()) + " " + _vm._s(props.row.amount_paid) + " ")])]) : _vm._e()] : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column4 = props.column) === null || _props$column4 === void 0 ? void 0 : _props$column4.field) === 'format_next_payment_date' ? [props.row.next_payment_date ? _c('div', [_vm._v(" " + _vm._s(_vm.formatDateTime(props.row.next_payment_date)) + " ")]) : _vm._e()] : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column5 = props.column) === null || _props$column5 === void 0 ? void 0 : _props$column5.field) === 'format_status' ? [_c('b-badge', {
          attrs: {
            "variant": _vm.getStatusVariant(props.row.status)
          }
        }, [_vm._v(" " + _vm._s(_vm.getStatusText(props.row.status)) + " ")])] : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column6 = props.column) === null || _props$column6 === void 0 ? void 0 : _props$column6.field) === 'format_payment_status' ? [_c('b-badge', {
          attrs: {
            "variant": _vm.getPaymentStatusVariant(props.row.payment_status)
          }
        }, [_vm._v(" " + _vm._s(props.row.payment_status) + " ")]), props.row.payment_status === 'UnPaid' ? _c('b-button', {
          staticClass: "mx-1",
          attrs: {
            "size": "sm",
            "variant": "primary"
          },
          on: {
            "click": function click($event) {
              return _vm.goToPayment(props.row);
            }
          }
        }, [_vm._v(" Invoice ")]) : _vm._e(), props.row.payment_status === 'Paid' ? _c('b-button', {
          staticClass: "mx-1",
          attrs: {
            "size": "sm",
            "variant": "primary"
          },
          on: {
            "click": function click($event) {
              return _vm.downloadInvoice(props.row);
            }
          }
        }, [_vm._v(" Download Invoice ")]) : _vm._e()] : _vm._e()];
      }
    }, {
      key: "pagination-bottom",
      fn: function fn(props) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between flex-wrap"
        }, [_c('div', {
          staticClass: "d-flex align-items-center mb-0 mt-1"
        }, [_c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(" Showing 1 to ")]), _c('b-form-select', {
          staticClass: "mx-1",
          attrs: {
            "options": ['10', '25', '50', '100', '500']
          },
          on: {
            "input": function input(value) {
              return props.perPageChanged({
                currentPerPage: value
              });
            }
          },
          model: {
            value: _vm.pageLength,
            callback: function callback($$v) {
              _vm.pageLength = $$v;
            },
            expression: "pageLength"
          }
        }), _c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(" of " + _vm._s(props.total) + " entries ")])], 1), _c('div', [_c('b-pagination', {
          staticClass: "mt-1 mb-0",
          attrs: {
            "value": 1,
            "total-rows": props.total,
            "per-page": _vm.pageLength,
            "first-number": "",
            "last-number": "",
            "align": "right",
            "prev-class": "prev-item",
            "next-class": "next-item"
          },
          on: {
            "input": function input(value) {
              return props.pageChanged({
                currentPage: value
              });
            }
          },
          scopedSlots: _vm._u([{
            key: "prev-text",
            fn: function fn() {
              return [_c('feather-icon', {
                attrs: {
                  "icon": "ChevronLeftIcon",
                  "size": "18"
                }
              })];
            },
            proxy: true
          }, {
            key: "next-text",
            fn: function fn() {
              return [_c('feather-icon', {
                attrs: {
                  "icon": "ChevronRightIcon",
                  "size": "18"
                }
              })];
            },
            proxy: true
          }], null, true)
        })], 1)])];
      }
    }])
  })], 1)]), _c('b-modal', {
    attrs: {
      "title": "Cancel Subscription",
      "hide-footer": ""
    },
    model: {
      value: _vm.showModal,
      callback: function callback($$v) {
        _vm.showModal = $$v;
      },
      expression: "showModal"
    }
  }, [_c('p', {
    staticClass: "my-2"
  }, [_vm._v("Do you want to cancel now or at the end of your package?")]), _c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "danger",
      "title": "If you cancel now, your subscription will end immediately. You won't be able to use the service after 24 hours."
    },
    on: {
      "click": _vm.pauseSubscription
    }
  }, [_vm._v(" Cancel Now ")]), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "warning",
      "title": "If you cancel at the end of the package, you can continue using your subscription until it expires. After that, access will be revoked."
    },
    on: {
      "click": _vm.cancelAtEndSubscription
    }
  }, [_vm._v(" Cancel at End of Package ")])], 1), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "secondary",
      "block": ""
    },
    on: {
      "click": function click($event) {
        _vm.showModal = false;
      }
    }
  }, [_vm._v(" Close ")])], 1), _c('b-sidebar', {
    attrs: {
      "id": "payment-sidebar",
      "title": "Complete Payment",
      "shadow": "",
      "right": "",
      "visible": _vm.showPaymentSidebar
    },
    on: {
      "hidden": function hidden($event) {
        _vm.showPaymentSidebar = false;
      }
    }
  }, [_c('div', {
    staticClass: "p-3"
  }, [_c('div', {
    staticClass: "border rounded bg-white p-3 shadow-sm"
  }, [_c('div', {
    staticClass: "text-center mb-4"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("INVOICE")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" Transaction ID: "), _c('strong', [_vm._v(_vm._s(((_vm$selectedPayment = _vm.selectedPayment) === null || _vm$selectedPayment === void 0 ? void 0 : _vm$selectedPayment.transaction_id) || 'N/A'))])])]), _c('div', {
    staticClass: "mb-3"
  }, [_c('h6', {
    staticClass: "text-primary"
  }, [_vm._v("Billed To:")]), _c('p', {
    staticClass: "mb-1"
  }, [_vm._v("Company Name: "), _c('strong', [_vm._v(_vm._s((_vm$companyInformatio = _vm.companyInformation) === null || _vm$companyInformatio === void 0 ? void 0 : _vm$companyInformatio.name))])]), _c('p', {
    staticClass: "mb-1"
  }, [_vm._v("E-mail: " + _vm._s((_vm$companyInformatio2 = _vm.companyInformation) === null || _vm$companyInformatio2 === void 0 ? void 0 : _vm$companyInformatio2.email))]), _c('p', [_vm._v("Contact No: " + _vm._s(((_vm$companyInformatio3 = _vm.companyInformation) === null || _vm$companyInformatio3 === void 0 ? void 0 : _vm$companyInformatio3.contact_no) || 'N/A'))]), _c('p', [_vm._v("Address: " + _vm._s(((_vm$companyInformatio4 = _vm.companyInformation) === null || _vm$companyInformatio4 === void 0 ? void 0 : _vm$companyInformatio4.address) || 'N/A'))])]), _c('table', {
    staticClass: "table table-sm mb-4"
  }, [_c('thead', {
    staticClass: "thead-light"
  }, [_c('tr', [_c('th', [_vm._v("Package")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Price (USD)")])])]), _c('tbody', [_c('tr', [_c('td', [_vm._v(" " + _vm._s((_vm$companyInformatio5 = _vm.companyInformation) === null || _vm$companyInformatio5 === void 0 ? void 0 : (_vm$companyInformatio6 = _vm$companyInformatio5.package) === null || _vm$companyInformatio6 === void 0 ? void 0 : _vm$companyInformatio6.title) + " "), _c('br'), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Billing Cycle: " + _vm._s((_vm$companyInformatio7 = _vm.companyInformation) === null || _vm$companyInformatio7 === void 0 ? void 0 : (_vm$companyInformatio8 = _vm$companyInformatio7.package) === null || _vm$companyInformatio8 === void 0 ? void 0 : _vm$companyInformatio8.billing_cycle))]), _vm._v(" "), _c('br'), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Max Users: " + _vm._s((_vm$companyInformatio9 = _vm.companyInformation) === null || _vm$companyInformatio9 === void 0 ? void 0 : (_vm$companyInformatio10 = _vm$companyInformatio9.package) === null || _vm$companyInformatio10 === void 0 ? void 0 : _vm$companyInformatio10.max_user))])]), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s((_vm$companyInformatio11 = _vm.companyInformation) === null || _vm$companyInformatio11 === void 0 ? void 0 : (_vm$companyInformatio12 = _vm$companyInformatio11.package) === null || _vm$companyInformatio12 === void 0 ? void 0 : _vm$companyInformatio12.price))])])]), _c('tfoot', [_c('tr', [_c('th', [_vm._v("Total")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s((_vm$selectedPayment2 = _vm.selectedPayment) === null || _vm$selectedPayment2 === void 0 ? void 0 : _vm$selectedPayment2.amount_paid) + " " + _vm._s((_vm$selectedPayment3 = _vm.selectedPayment) === null || _vm$selectedPayment3 === void 0 ? void 0 : _vm$selectedPayment3.currency))])])])]), _c('div', {
    staticClass: "mb-3"
  }, [_c('p', {
    staticClass: "mb-1"
  }, [_c('strong', [_vm._v("Status: ")]), _c('b-badge', {
    attrs: {
      "variant": ((_vm$selectedPayment4 = _vm.selectedPayment) === null || _vm$selectedPayment4 === void 0 ? void 0 : _vm$selectedPayment4.payment_status) === 'Paid' ? 'success' : 'danger'
    }
  }, [_vm._v(" " + _vm._s((_vm$selectedPayment5 = _vm.selectedPayment) === null || _vm$selectedPayment5 === void 0 ? void 0 : _vm$selectedPayment5.payment_status) + " ")])], 1), _c('p', {
    staticClass: "mb-1"
  }, [_c('strong', [_vm._v("Next Payment Date:")]), _vm._v(" " + _vm._s(_vm.formatDateTime((_vm$selectedPayment6 = _vm.selectedPayment) === null || _vm$selectedPayment6 === void 0 ? void 0 : _vm$selectedPayment6.next_payment_date)) + " ")])]), _c('hr'), _c('b-form-checkbox', {
    staticClass: "mb-2",
    attrs: {
      "disabled": ((_vm$selectedPayment7 = _vm.selectedPayment) === null || _vm$selectedPayment7 === void 0 ? void 0 : _vm$selectedPayment7.payment_status) === 'Paid'
    },
    model: {
      value: _vm.confirmChecked,
      callback: function callback($$v) {
        _vm.confirmChecked = $$v;
      },
      expression: "confirmChecked"
    }
  }, [_vm._v(" I agree with "), _c('a', {
    attrs: {
      "href": "https://hrms.taskfino.com/terms-and-condition",
      "target": "_blank"
    }
  }, [_vm._v("Terms and Conditions")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "https://hrms.taskfino.com/return-and-refund",
      "target": "_blank"
    }
  }, [_vm._v("Return and Refund Policy")]), _vm._v(", and "), _c('a', {
    attrs: {
      "href": "https://hrms.taskfino.com/privacy-policy",
      "target": "_blank"
    }
  }, [_vm._v("Privacy Policy")]), _vm._v(". ")]), _c('div', {
    staticClass: "mb-2"
  }, [_vm.confirmChecked ? _c('b-alert', {
    attrs: {
      "variant": "warning",
      "show": ""
    }
  }, [_vm._v(" ⚠️ Please ensure your information is accurate before proceeding. Payments are non-refundable once confirmed. ")]) : _vm._e()], 1), _c('b-button', {
    attrs: {
      "block": "",
      "variant": "primary",
      "size": "lg",
      "disabled": !_vm.confirmChecked || ((_vm$selectedPayment8 = _vm.selectedPayment) === null || _vm$selectedPayment8 === void 0 ? void 0 : _vm$selectedPayment8.payment_status) === 'Paid'
    },
    on: {
      "click": _vm.confirmPayment
    }
  }, [_vm._v(" " + _vm._s(((_vm$selectedPayment9 = _vm.selectedPayment) === null || _vm$selectedPayment9 === void 0 ? void 0 : _vm$selectedPayment9.payment_status) === 'Paid' ? 'Already Paid' : 'Pay Now') + " ")])], 1)])]), _c('b-modal', {
    attrs: {
      "id": "payment-success-modal",
      "title": "Payment Successful",
      "centered": "",
      "ok-only": "",
      "ok-variant": "success"
    },
    on: {
      "ok": _vm.goToPaymentHistories
    }
  }, [_c('div', {
    staticClass: "text-center py-3"
  }, [_c('b-icon', {
    attrs: {
      "icon": "check-circle-fill",
      "variant": "success",
      "font-scale": "3"
    }
  }), _c('p', {
    staticClass: "mt-3 mb-0"
  }, [_vm._v("Your payment was completed successfully.")])], 1)]), _c('b-modal', {
    attrs: {
      "id": "payment-fail-modal",
      "title": "Payment Failed",
      "centered": "",
      "ok-only": "",
      "ok-variant": "danger"
    },
    on: {
      "ok": _vm.goToPaymentHistories
    }
  }, [_c('div', {
    staticClass: "text-center py-3"
  }, [_c('b-icon', {
    attrs: {
      "icon": "x-circle-fill",
      "variant": "danger",
      "font-scale": "3"
    }
  }), _c('p', {
    staticClass: "mt-3 mb-0"
  }, [_vm._v("Your payment could not be processed. Please try again.")])], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }